import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Post(props) {
    return (
        <SvgIcon {...props}>
            <path fill="#FA992D" d="M50 2c4.8 2.8 9.6 5.6 14.3 8.4-13.9 8-27.7 15.9-41.6 23.9-1.5-.8-2.9-1.5-4.4-2.3-3.4-2-6.7-4.1-10.1-6.1L48.4 2.8c.4-.2.8-.5 1.2-.8h.4zM91.3 25.9c.1.3.3.7.3 1v46.4c0 .4-.2.9-.5 1.1C77.4 82.2 63.7 90.1 50 98c-.1-.4-.2-.8-.2-1.3V50.1c9.7-5.6 19.5-11.2 29.2-16.8 4.1-2.4 8.2-4.9 12.3-7.4z" /><path fill="#FEB639" d="M49.8 50.1v46.6c0 .4.1.8.2 1.3-.3-.1-.6-.1-.8-.2C35.7 90 22.3 82.3 8.8 74.5c-.4-.2-.8-.9-.8-1.4V27c0-.4.2-.7.3-1.1 3.4 2 6.7 4.1 10.1 6.1 1.4.8 2.9 1.5 4.4 2.3-.1.1-.1.3-.2.4v19.9c0 .3 0 .7.2.8 4.1 2.4 8.1 4.7 12.3 7.1V41.6h.2c4.9 2.8 9.7 5.7 14.5 8.5z" /><path fill="#F57A21" d="M49.8 50.1c-4.8-2.8-9.6-5.6-14.5-8.4.3-.2.5-.3.8-.5 13.6-7.8 27.2-15.6 40.8-23.5 4.8 2.7 9.6 5.5 14.4 8.2-4.1 2.5-8.2 5-12.3 7.4-9.7 5.6-19.5 11.2-29.2 16.8z" /><path fill="#FED387" d="M76.9 17.7c-13.6 7.8-27.2 15.6-40.8 23.5-.3.2-.5.3-.8.5h-.2c-.4-.2-.7-.4-1.1-.6-3.8-2.1-7.7-4.2-11.5-6.4.1-.1.1-.3.2-.4 13.9-8 27.7-15.9 41.6-23.9 4.2 2.4 8.4 4.8 12.6 7.3z" /><path fill="#FEE9C2" d="M22.6 34.7c3.8 2.1 7.7 4.2 11.5 6.4.4.2.7.4 1.1.6v20.9c-4.2-2.4-8.3-4.8-12.3-7.1-.2-.1-.2-.6-.2-.8-.1-6.8-.1-13.4-.1-20z" />
        </SvgIcon>
    );
}

Post.defaultProps = {
    viewBox: '0 0 100 100'
};

export default Post;
